module.exports = __webpack_public_path__ + "img/MyPageBackground.bf097c97.jpg";